import { applyContentLocaleToUrl } from './contentLocaleQuery';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';

const SESSION_KEY = 'lewouhmart_reco_session';

export type RecommendationEventType = 'PRODUCT_VIEW' | 'ADD_TO_CART' | 'RECOMMENDATION_CLICK';

export function getRecommendationSessionId() {
  try {
    const existing = window.localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const generated = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    window.localStorage.setItem(SESSION_KEY, generated);
    return generated;
  } catch {
    return `sess_${Date.now()}`;
  }
}

export async function trackRecommendationEvent(payload: {
  productId: string;
  eventType: RecommendationEventType;
  context?: string;
  source?: string;
}) {
  try {
    await fetch(
      applyContentLocaleToUrl(
        `${API_BASE}/public/recommendations/track`,
        navigator.language,
      ),
      {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: getRecommendationSessionId(),
        productId: payload.productId,
        eventType: payload.eventType,
        context: payload.context,
        source: payload.source,
      }),
      },
    );
  } catch {
    // best effort
  }
}

